export default __webpack_public_path__ + "static/digilock-houston-297db50569429b0f333b500eb2b68bf0.jpg";